import { components } from "@certn/api/generated-schemas/client-portal";
import { Stack, Text } from "@certn/cascadia";
import { Divider, GhostIconButton } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useCanViewClientPortalPricing } from "../../../permissions/Permissions";
import { formatNullableCurrency } from "../../../../utils/formatNullableCurrency";
import { getCheckDisplayNameFromCheck } from "./utils";

export function UmbrellaCheckSection({
  umbrellaCheck,
  onUmbrellaCheckSelect,
}: {
  umbrellaCheck: components["schemas"]["CheckListChild"];
  onUmbrellaCheckSelect: (
    selected: components["schemas"]["CheckListChild"]
  ) => void;
}) {
  const { t } = useTranslation();
  const canViewClientPortalPricing = useCanViewClientPortalPricing();
  const displayName = getCheckDisplayNameFromCheck(umbrellaCheck, "FULL_LIST");
  const formattedPrice = formatNullableCurrency(umbrellaCheck.price, {
    currency: umbrellaCheck.currency,
  });

  return (
    <>
      <div className={css(styles.container)}>
        <Stack orientation="horizontal">
          <Text style="global/heading-medium" marginTop="space-4">
            {displayName}
          </Text>
        </Stack>
        <Stack orientation="horizontal">
          <Text style="global/heading-medium" color="text-accent-tofino">
            {canViewClientPortalPricing ? formattedPrice : ""}
          </Text>
          <GhostIconButton
            testID="learn-more-modal-umbrella-check-select-button"
            onPress={() => onUmbrellaCheckSelect(umbrellaCheck)}
            size="medium"
            icon="chevron_right"
            aria-label={t(`{{title}} - close detail`, {
              title: displayName,
            })}
          />
        </Stack>
      </div>
      <Divider />
    </>
  );
}

const styles = {
  container: css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    padding: `${"var(--space-2)"} ${"var(--space-0)"} ${"var(--space-2)"} ${"var(--space-0)"}`,
  }),
};
